module.exports = __webpack_public_path__ + "media/images/tips-6c1f30bc7e5b52b3012b0e967f4dec81.svg";